/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleCalendarStatusResponseDto
 */
export interface GoogleCalendarStatusResponseDto {
    /**
     * Whether the provider has connected a Google account
     * @type {boolean}
     * @memberof GoogleCalendarStatusResponseDto
     */
    connected: boolean;
    /**
     * The connected Google account email
     * @type {string}
     * @memberof GoogleCalendarStatusResponseDto
     */
    email?: string;
}

/**
 * Check if a given object implements the GoogleCalendarStatusResponseDto interface.
 */
export function instanceOfGoogleCalendarStatusResponseDto(value: object): value is GoogleCalendarStatusResponseDto {
    if (!('connected' in value) || value['connected'] === undefined) return false;
    return true;
}

export function GoogleCalendarStatusResponseDtoFromJSON(json: any): GoogleCalendarStatusResponseDto {
    return GoogleCalendarStatusResponseDtoFromJSONTyped(json, false);
}

export function GoogleCalendarStatusResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleCalendarStatusResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'connected': json['connected'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function GoogleCalendarStatusResponseDtoToJSON(json: any): GoogleCalendarStatusResponseDto {
    return GoogleCalendarStatusResponseDtoToJSONTyped(json, false);
}

export function GoogleCalendarStatusResponseDtoToJSONTyped(value?: GoogleCalendarStatusResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'connected': value['connected'],
        'email': value['email'],
    };
}

